"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariantPicker = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Option = require("./Option");
var _utils = require("./utils");
require("./VariantPicker.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var VariantPicker = function VariantPicker(_ref) {
  var variantGroups = _ref.variantGroups,
    hasSelectionError = _ref.hasSelectionError,
    onSelect = _ref.onSelect,
    errorMessage = _ref.errorMessage;
  var _useState = (0, _react.useState)((0, _utils.getInitialAvailability)(variantGroups)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    availability = _useState2[0],
    setAvailability = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    highlights = _useState4[0],
    setHighlights = _useState4[1];
  var handleMouseOver = function handleMouseOver(groupId) {
    return function (option) {
      if (variantGroups.length > 2) {
        return;
      }
      setAvailability((0, _utils.getAvailability)(variantGroups, option, groupId));
      setHighlights((0, _utils.getHighlights)(option));
    };
  };
  var handleMouseOut = function handleMouseOut() {
    setAvailability((0, _utils.getInitialAvailability)(variantGroups));
    setHighlights({});
  };
  var rootClassName = (0, _classnames["default"])('cds-VariantPicker', {
    'cds-VariantPicker--ManyGroupHover': (variantGroups === null || variantGroups === void 0 ? void 0 : variantGroups.length) > 2
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, variantGroups.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: "cds-VariantGroup",
      key: group.id
    }, /*#__PURE__*/_react["default"].createElement("legend", {
      className: "cds-VariantGroup-AttrName"
    }, group.label, ":", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: "cds-VariantGroup-AttrValue"
    }, group.selected)), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "cds-VariantPicker-List"
    }, group.options.map(function (option) {
      var isAvailable = (availability[group.id] || []).includes(option.value);
      var isHighlighted = (highlights[group.id] || []).includes(option.value);
      return /*#__PURE__*/_react["default"].createElement(_Option.Option, (0, _extends2["default"])({
        option: option,
        onSelect: onSelect
      }, variantGroups.length <= 2 && {
        onMouseOver: handleMouseOver(group.id),
        onMouseOut: handleMouseOut
      }, {
        isAvailable: isAvailable,
        isHighlighted: isHighlighted,
        key: option.value
      }));
    })));
  }), hasSelectionError && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-VariantPicker-Error"
  }, errorMessage));
};
exports.VariantPicker = VariantPicker;